import dompurify from 'dompurify'
import { UAParser } from 'ua-parser-js'
import { useQuery } from 'villus'

import { checkAndResetProduct } from '@/data/hardCode'
import {
  ArtworkType,
  CollageDocument,
  type CollageWithDesignInfoCommonFieldsFragment,
  CustomizationLevel,
} from '@/graphql/creator-platform/generated'
import { backendLocation } from '@/graphql/utils'
import { useDittoDesignStore } from '@/store/dittoDesignStore'

import { LocalStorage } from './storage'

export const popularList = [
  'The Girl',
  'LAZY MONSTER',
  'wohenlanduo',
  'Jin Jin Tattoo',
  'Rachel Liao',
]

export function cleanTranslation(dirty: string): string {
  // TODO(Carl): 研究實作 CSP 加強資安防護
  return dompurify.sanitize(dirty, {
    ALLOWED_TAGS: ['a', 'u', 'span', 'br', 'li', 'ul', 'img'],
    ALLOWED_ATTR: ['target', 'href', 'class', 'src'],
  })
}

const unsupportedBrowser = new Set([
  'Firefox',
  'Quark',
  'Samsung Browser',
  'Samsung Internet',
  'TikTok',
])
export function isUnsupportedBrowser(): boolean {
  // workaround handle FxQuantum before UAParser can identify it
  if (navigator.userAgent.includes('FxQuantum')) {
    return true
  }
  const ua = new UAParser(navigator.userAgent)
  const browser = ua.getBrowser().name ?? ''
  return unsupportedBrowser.has(browser)
}

export function isArtworkType(type: unknown): type is ArtworkType {
  const types: string[] = Object.values(ArtworkType)
  return typeof type === 'string' && types.includes(type)
}

export const defaultAvatar = '/default-avatar.svg'

export function isURL(value: unknown): value is `https://${string}` {
  const urlPattern = /^https:\/\/[^\s/$.?#].\S*$/i
  return typeof value === 'string' && urlPattern.test(value)
}

export async function applyCollage(
  collageId: string,
): Promise<CollageWithDesignInfoCommonFieldsFragment | null> {
  const dittoDesignStore = useDittoDesignStore()

  const query = await useQuery({
    query: CollageDocument,
    variables: {
      idOrDisplayId: collageId,
      location: backendLocation,
    },
  })
  const collage = query.data.value?.collageForDitto
  if (collage === undefined) {
    return null
  }

  // 先確保 product 跟 artwork 的 boundDesignGroup 一致
  // 再 apply design 以免在 product init 就被清掉
  await checkAndResetProduct(collage.designGroupType)
  await dittoDesignStore.convertCollageAndAppendToStore(collage, true)
  localStorage.setItem(LocalStorage.DesignCustomizationLevel, collage.customizationLevel)
  localStorage.removeItem(LocalStorage.ArtistIdForCustomization)
  if (collage.customizationLevel === CustomizationLevel.NoMixedArtistWork) {
    localStorage.setItem(LocalStorage.ArtistIdForCustomization, collage.creator.id)
  }

  return collage
}
